import { ArrowUpRight } from 'lucide-react';
import { useRadarLocale } from '@/i18n/RadarLocaleContext';
import type { RadarWatch } from './types';
import { RadarItemView } from './RadarItemView';
import { radarAnalytics, type RadarProperties } from './radarAnalytics';

export function currentCompanyRoutes(watch: RadarWatch) {
  if (watch.status === 'needs_confirmation') return [];
  return (watch.company_routes || []).filter(route => route.kind === 'company_email'
    && /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(route.email)
    && /^https?:\/\//i.test(route.source_url)
    && Number.isFinite(new Date(route.checked_at).getTime()));
}

export function RadarCompanyRoutes({ watch, workspaceId, screen = 'watch', active = true, signalsOnly=false }:
  { watch: RadarWatch; workspaceId?: string; screen?: 'watch' | 'act'; active?: boolean;signalsOnly?:boolean }) {
  const { t, locale } = useRadarLocale();
  const routes = currentCompanyRoutes(watch);
  if (!routes.length) return null;
  const retry = watch.next_contact_at && new Date(watch.next_contact_at);
  const properties: RadarProperties = { workspace_id: workspaceId, company_id: watch.company_id,
    watch_id: watch.id, plan_id: watch.plan_id, screen, item_type: 'company_email', item_id: watch.company_id, channel: 'email' };
  return <RadarItemView properties={{...properties, collection_count: routes.length}} active={active}
    className="radar-contact-section radar-company-routes" aria-label={t('Company contact entry points')}>
    <span className="radar-card-label">{t('Company contact entry points')}</span>
    {routes.map((route, index) => <div className="radar-company-route" key={route.email}>
      <strong>{t('Official website · Company email')}</strong>
      <a href={`mailto:${route.email}`} onClick={() => { if (workspaceId && active) radarAnalytics.capture('radar_item_opened', {...properties, item_index: index}); }}>{route.email}</a>
      <small>{t('Shared mailbox. Personal ownership and deliverability have not been verified.')}</small>
      <small>{t('Last checked on the official website · {date}', {date: new Date(route.checked_at).toLocaleDateString(locale)})}</small>
      <a className="radar-watch-source" href={route.source_url} target="_blank" rel="noreferrer"
        onClick={() => { if (workspaceId && active) radarAnalytics.capture('radar_item_opened', {...properties, item_type: 'evidence', source_kind: 'company_email', source_index: index}); }}>
        {t('View official source')} <ArrowUpRight size={14}/>
      </a>
    </div>)}
    {(!signalsOnly||screen==='act') && !watch.contacts?.length && watch.status === 'active' && retry && Number.isFinite(retry.getTime()) &&
      <p className="radar-watch-note">{t('Next search for a personal contact · {date}', {date: retry.toLocaleDateString(locale)})}</p>}
    {(!signalsOnly||screen==='act') && watch.status === 'paused' && <p className="radar-watch-note">{t('Preparation paused')}</p>}
  </RadarItemView>;
}
